import React from 'react';

/**
 * Visible row auto-number for Events module tables.
 *
 * Default order is "desc": top/first visible row = highest number; last/bottom = 1.
 * Prefer total + page + limit so numbering is continuous across pages.
 * Falls back to reverse within the current visible rows when total is unknown.
 *
 * Pass order="asc" only if a specific table must number top→1.
 */
export function eventTableRowNumber(index = 0, opts = {}) {
  const i = Math.max(0, Number(index) || 0);
  const order = opts?.order === 'asc' ? 'asc' : 'desc';

  if (order === 'asc') {
    return i + 1;
  }

  const page = Math.max(1, Number(opts.page) || 1);
  const limit = Math.max(0, Number(opts.limit) || 0);
  const total = Number(opts.total);
  const rowCount = Math.max(0, Number(opts.rowCount) || 0);
  const offset = limit > 0 ? (page - 1) * limit : 0;
  const position = offset + i;

  if (Number.isFinite(total) && total > 0) {
    return Math.max(1, Math.trunc(total) - position);
  }

  const visible = rowCount > 0 ? rowCount : i + 1;
  return Math.max(1, visible - i);
}

const thBase =
  'px-3 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider whitespace-nowrap w-12';
const tdBase = 'px-3 py-3 text-sm text-gray-500 tabular-nums whitespace-nowrap';

/** Table header cell for the serial column. */
export function EventTableSerialTh({ className = '', label = '#' }) {
  return (
    <th scope="col" className={`${thBase} ${className}`.trim()}>
      {label}
    </th>
  );
}

/**
 * Table body cell showing the serial number for a row.
 * Defaults to descending (top = highest). Pass total/page/limit or rowCount.
 */
export function EventTableSerialTd({
  index = 0,
  page,
  limit,
  total,
  rowCount,
  order = 'desc',
  className = '',
  children,
}) {
  const n = children != null
    ? children
    : eventTableRowNumber(index, { order, page, limit, total, rowCount });
  return (
    <td className={`${tdBase} ${className}`.trim()}>
      {n}
    </td>
  );
}
